module.exports = new __parcel__URL__("location-dark.395fc7dc.svg").toString();